var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28678 2C5.30555 2 2.07812 5.15614 2.07812 9.04945C2.07812 12.9427 5.30555 16.0989 9.28678 16.0989C10.9895 16.0989 12.5544 15.5216 13.7879 14.5561L16.1309 16.8415L16.1932 16.894C16.4108 17.0514 16.7192 17.0335 16.916 16.8405C17.1326 16.6282 17.1321 16.2845 16.915 16.0727L14.5995 13.8142C15.7768 12.5595 16.4954 10.8866 16.4954 9.04945C16.4954 5.15614 13.268 2 9.28678 2ZM9.28678 3.0858C12.6548 3.0858 15.3851 5.75582 15.3851 9.04945C15.3851 12.3431 12.6548 15.0131 9.28678 15.0131C5.91877 15.0131 3.18845 12.3431 3.18845 9.04945C3.18845 5.75582 5.91877 3.0858 9.28678 3.0858Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.4a695cde77f909445eb52aee904c607e.svg";
export { ForwardRef as ReactComponent };